"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AutoComplete_1 = __importDefault(require("./AutoComplete"));
var remote_1 = __importDefault(require("./remote"));
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var RemoteAutoComplete = remote_1.default(AutoComplete_1.default);
exports.default = RemoteAutoComplete;
exports.FormRemoteAutoComplete = reduxFormWrappers_1.formWrapper(RemoteAutoComplete);
//# sourceMappingURL=AutoCompleteRemote.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/AutoCompleteRemote.js
// module id = 271
// module chunks = 0